import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCallListProfileList extends Layout {
    layoutheaderSearchCallListProfiles: LayoutHeader;
    sourceCallListProfile: DataSource;
    tableCallListProfiles: Table;
}
